import './App.css';
import About from './Components/About/About';
import NavbarN from './Components/NavbarN/NavbarN';

function App() {
  return (
    <div className="App">
   <NavbarN />
   <About />
    </div>
  );
}

export default App;
